import type { ReactElement } from 'react';

import { useTranslation } from 'react-i18next';

import { colorsPalette } from '@/features/cv/templates/colors.constant.ts';

import type { ClassicParams } from './schema';

import { TemplateEditPannelProps } from '../types';

export default function ClassicEditPannel({
  params,
  onChangeParams,
}: TemplateEditPannelProps<ClassicParams>): ReactElement {
  const { t } = useTranslation();

  return (
    <div className="p-3 w-72 space-y-4">
      <div className="text-sm font-semibold mb-2">{t('CV.Classic.accentColor')}</div>
      <div className="grid grid-cols-8 gap-2">
        {colorsPalette.map(color => (
          <button
            key={color}
            type="button"
            aria-label={`${t('CV.Classic.accentColor')} ${color}`}
            className="h-6 w-6 rounded-full border cursor-pointer"
            style={{
              backgroundColor: color,
              outline: params.accentColor === color ? `2px solid ${color}` : undefined,
            }}
            onClick={() => onChangeParams({ ...params, accentColor: color })}
          />
        ))}
      </div>
    </div>
  );
}
